// Time zone helpers — all timestamps are stored in UTC; display is localized.

export const detectTz = () => {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "Australia/Sydney"; }
    catch { return "Australia/Sydney"; }
};

export const userTz = (user) => user?.timezone || detectTz();

export const fmtLocal = (iso, tz) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("en-AU", {
            timeZone: tz || detectTz(),
            day: "2-digit", month: "short", year: "numeric",
            hour: "2-digit", minute: "2-digit", timeZoneName: "short",
        });
    } catch { return String(iso).replace("T", " ").slice(0, 16); }
};

export const tzAbbr = (tz) => {
    if (!tz) return "";
    try {
        const parts = new Intl.DateTimeFormat("en-AU", { timeZone: tz, timeZoneName: "short" }).formatToParts(new Date());
        return parts.find((p) => p.type === "timeZoneName")?.value || tz;
    } catch { return tz; }
};

export const COMMON_TZS = [
    "Australia/Brisbane", "Australia/Sydney", "Australia/Melbourne", "Australia/Adelaide",
    "Australia/Perth", "Australia/Darwin", "Australia/Hobart",
    "Pacific/Auckland", "Asia/Singapore", "Asia/Tokyo", "Asia/Kolkata", "Asia/Dubai",
    "Europe/London", "Europe/Berlin", "America/New_York", "America/Chicago",
    "America/Denver", "America/Los_Angeles", "UTC",
];
